import LineChartWidget from './line-chart.widget';
export default LineChartWidget;
